import { render, staticRenderFns } from "./RelatedBusiness.vue?vue&type=template&id=ffdd5f98&scoped=true&"
import script from "./RelatedBusiness.vue?vue&type=script&lang=js&"
export * from "./RelatedBusiness.vue?vue&type=script&lang=js&"
import style0 from "./RelatedBusiness.vue?vue&type=style&index=0&id=ffdd5f98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdd5f98",
  null
  
)

component.options.__file = "RelatedBusiness.vue"
export default component.exports